import React from 'react';
import FAutoCombo from './FAutoCombo';
import { AutoComboWrapperProps } from './autoCombo.models';

class AutoIxCombo extends React.PureComponent<AutoComboWrapperProps> {
  render() {
    return <FAutoCombo {...this.props} valueMode="ix" />;
  }
}

export default AutoIxCombo;
